<template>
<div class="full-parent-side">


  <div class="lock-sticky  left-sticky-1">
    <div :class="['sidebar white-bg pt-2 ', { compact: compare == 2 }, {
                'disable-side-btn': disable,
              },]">
      <b-container fluid style="padding-left:10px;">
        <b-row class="compact-show">
          <b-col>
            <p class="text-black">
              <strong> Select your account: </strong>
            </p>
          </b-col>
        </b-row>

        <b-row
          class="h-100"
          :class="[
            'button-action padding-2 padding-removed-custom',
            { active: activeProductType == 'Suite' },
          ]"
          @click="accountType('Suite')"
        >
          <b-col md="3" class="image-change my-auto">
            <img src="@/assets/images/icons/Account-Suite-Gradient.svg" v-show="activeProductType == 'Suite'" class="image-side-bars"/>
            <img src="@/assets/images/icons/Account-Suite-Grey.svg" v-show="activeProductType != 'Suite'" class="image-side-bars">
          </b-col>
          <b-col md="8" class="compact-show my-auto">
            <h5 class="pb-0 mb-0">Full banking suite</h5>
            <p></p>
          </b-col>
        </b-row>

        <b-row
          :class="[
            'button-action padding-2 padding-removed-custom',
            { active: activeProductType == 'Card Account' },
            {
              'disable-side-btn':disable
            }
          ]"
          @click="accountType('Card Account')"
        >
          <b-col md="3" class="text-center image-change my-auto">
            <img src="@/assets/images/icons/Account-Credit-Gradient.svg"  v-show="activeProductType == 'Card Account'" class="image-side-bars"/>
          <img src="@/assets/images/icons/Account-Credit-Grey.svg" v-show="activeProductType != 'Card Account'" class="image-side-bars">
          </b-col>
          <b-col md="8" :class="['compact-show side-bar-text-size',{'gray-out':disable}]">
            <h5 class="pb-0 mb-0">Credit card</h5>
            <p>account</p>
          </b-col>
        </b-row>
        <b-row
          :class="[
            'button-action padding-2 padding-removed-custom',
            {
              active:
                 activeProductType == 'Transaction Account (bundled fees)',
            }, {
              'disable-side-btn':disable
            }
          ]"
          @click="
            accountType('Transaction Account (bundled fees)')
          "
        >
          <b-col md="3" class="image-change my-auto">
            <img src="@/assets/images/icons/Account-Transaction-Bundled-Gradient.svg" v-show="activeProductType == 'Transaction Account (bundled fees)'"  class="image-side-bars"/>
            <img src="@/assets/images/icons/Account-Transaction-Bundled-Grey.svg" v-show="activeProductType != 'Transaction Account (bundled fees)'"
          class="image-side-bars">
          </b-col>
          <b-col md="8" :class="['compact-show side-bar-text-size',{'gray-out':disable}]">
            <h5 class="pb-0 mb-0">Transaction</h5>
            <p>with bundled fees</p>
          </b-col>
        </b-row>
        <b-row
          :class="[
            'button-action padding-2 padding-removed-custom',
            {
              active:
              activeProductType =='Transaction Account (pay-as-you-transact fees)',
            },
            {
              'disable-side-btn':disable
            }
          ]"
          @click="accountType('Transaction Account (pay-as-you-transact fees)')"
        >
          <b-col md="3" class="image-change my-auto">
            <img src="@/assets/images/icons/Account-Transaction-Gradient.svg" v-show="activeProductType == 'Transaction Account (pay-as-you-transact fees)'"  class="image-side-bars"/>
            <img src="@/assets/images/icons/Account-Transaction-Grey.svg" v-show="activeProductType != 'Transaction Account (pay-as-you-transact fees)'"  class="image-side-bars"/>
          </b-col>
          <b-col md="8" :class="['compact-show side-bar-text-size',{'gray-out':disable}]">
            <h5 class="pb-0 mb-0">Transaction</h5>
            <p>with pay-as-you-transact fees</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div :class="['sidebar padding-2 padding-removed-custom mt-2 text-white',healthMemberAct=='yes'?'blue-bg':'grey-bg']">
      <b-container fluid class="">
        <b-row h-100>
          <b-col md="3" class="my-auto"> <img src="@/assets/images/icons/running_man.svg" class="image-side-bars"> </b-col>
          <b-col md="9" class="compact-show pb-1">
            <p class="p-bottom text-center">Are you a <strong>Vitality <br> Health </strong>member?</p>
            <div class="inline-radio">
              <b-form-radio v-model="healthMemberAct" value="yes" class="radio-blue"
                >Yes</b-form-radio
              >
              <b-form-radio v-model="healthMemberAct" value="no" class="radio-blue"
                >No</b-form-radio
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div :class="['sidebar padding-2 padding-removed-custom mt-2 text-white',driveMemberAct=='yes'?'purple-bg':'grey-bg']">
      <b-container fluid class="">
        <b-row h-100>
          <b-col md="3" class="my-auto"> 
            <img src="@/assets/images/icons/car.svg" alt=""  class="image-side-bars">
             </b-col>
          <b-col md="9" my-auto class="compact-show pb-1">
            <p class="p-bottom text-center">Are you a <strong>Vitality <br> Drive </strong>member?</p>
            <div class="inline-radio">
              <b-form-radio  v-model="driveMemberAct" value="yes" class="radio-purple"
                >Yes</b-form-radio
              >
              <b-form-radio v-model="driveMemberAct"  value="no" class="radio-purple"
                >No</b-form-radio
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    compare: { default: 1 },
    driveMemberActive: {
      default: "yes",
    },
    healthMemberActive: {
      default: "yes",
    },
    activeProductType:{
        default:'Suite'
    },
    disable:{
      default:false
    }
  },
  data(){
return {
    driveMemberAct:this.driveMemberActive,
    healthMemberAct:this.healthMemberActive
}
  },
  methods: {
    driveMember(item) {
        },
    accountType(item) {
      if(this.disable!=true){

        this.$emit("account", item);
      }
    },
    healthMember(item) {
        this.$emit("health", item);
    },
  },
  watch:{
      driveMemberAct(){
          if(this.driveMemberAct=='yes'){

              this.$emit("drive", 'yes');
          }else{
              this.$emit("drive", 'no');
              
          }
      },
      healthMemberAct(){
          if(this.healthMemberAct=='yes'){

              this.$emit("health", 'yes');
          }else{
              this.$emit("health", 'no');
              
          }
      }
  }
};
</script>

<style lang="scss" scoped>
.full-parent-side{
  position: absolute;
  left:0;
}
.p-bottom{
  margin-bottom: 0.25rem;
}
</style>